import React, { useEffect } from 'react';
import Navbar from '../components/home/Navbar';
import HeroSection from '../components/home/HeroSection';
import WhyChooseUs from '../components/home/WhyChooseUs';
import TimeTableSection from '../components/home/TimeTableSection';
import ReachPotentialSection from '../components/home/ReachPotentialSection';
import WhySudeshMathsSection from '../components/home/WhySudeshMathsSection';
import TestimonialsSection from '../components/home/TestimonialsSection';
import FAQSection from '../components/home/FAQSection';
import Footer from '../components/home/Footer';
import FloatingAction from '../components/home/FloatingAction';

// Add fonts using React useEffect to avoid CSP issues
const fontStyle = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Nunito:wght@600;700;800;900&display=swap');
  .lemon-milk {
    font-family: 'Nunito', sans-serif !important;
    font-weight: 800;
  }
  .poppins {
    font-family: 'Poppins', sans-serif !important;
`;

export default function Home() {
  // Load fonts safely
  useEffect(() => {
    const styleSheet = document.createElement('style');
    styleSheet.type = 'text/css';
    styleSheet.innerHTML = fontStyle;
    document.head.appendChild(styleSheet);

    return () => {
      document.head.removeChild(styleSheet);
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <HeroSection />
      <WhyChooseUs />
      <TimeTableSection />
      <ReachPotentialSection />
      <WhySudeshMathsSection />
      <TestimonialsSection />
      <FAQSection />
      <Footer />
      <FloatingAction />
    </div>
  );
}
